// extracted by mini-css-extract-plugin
export default {"root":"PowerTranzPayLink_root__CwWK6","card":"PowerTranzPayLink_card__e6tad"};